import { Box, useTheme } from '@mui/material';
import MuiMarkdown from 'mui-markdown';

export default function AiChatAssistantMessage({ content, isStreaming }: { content: string; isStreaming?: boolean }) {
  const theme = useTheme();

  // Ensure content is always a string
  const safeContent = typeof content === 'string' ? content : String(content || '');

  return (
    <Box
      sx={{
        whiteSpace: 'pre-wrap',
        opacity: isStreaming ? 0.8 : 1,
        '& table': { mb: 2, borderCollapse: 'collapse' },
        '& th, & td': { padding: theme.spacing(0.5, 1) },
        '& h1': { fontSize: theme.typography.h5.fontSize, lineHeight: theme.typography.h5.lineHeight },
        '& h2': { fontSize: theme.typography.h6.fontSize, lineHeight: theme.typography.h6.lineHeight },
        '& h3': {
          fontSize: theme.typography.subtitle1.fontSize,
          lineHeight: theme.typography.subtitle1.lineHeight ?? 1.4,
        },
        '& h4, & h5, & h6': {
          fontSize: theme.typography.subtitle2.fontSize,
          lineHeight: theme.typography.subtitle2.lineHeight ?? 1.4,
        },
        '& strong': { fontWeight: 600 },
      }}
    >
      <MuiMarkdown>{safeContent}</MuiMarkdown>
    </Box>
  );
}
